import { useModuleEnabled } from '@/hooks/useModuleEnabled'
import type { ModuleConfig } from '@/types/modules'

interface ModuleGateProps {
  module: keyof ModuleConfig
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function ModuleGate({ module, children, fallback = null }: ModuleGateProps) {
  const enabled = useModuleEnabled(module)
  return enabled ? <>{children}</> : <>{fallback}</>
}
